import React, { useState } from 'react';
import { toast } from 'react-toastify';

import AppDeleteModal from 'components/new_components/AppDeleteModalNew';

// redux
import { useDispatch } from 'react-redux';
import { DeleteKycResult } from 'store/actions/FraudGauardianActions';

const DeleteModal = (props) => {
    const { open, handleClose, id } = props;

    const [deleting, setDeleting] = useState(false);
    const dispatch = useDispatch();

    //function
    const handleDelete = async () => {
        setDeleting(true);
        const res = await dispatch(DeleteKycResult(id));
        setDeleting(false);
        if (res?.success) {
            toast.success('Successfully deleted a kycrecord.');
            handleClose();
        } else {
            toast.error(res?.message);
        }
    };

    return (
        <AppDeleteModal
            open={open}
            handleClose={handleClose}
            deleting={deleting}
            onDelete={handleDelete}
            actionsPosition="center"
        />
    );
};
export default DeleteModal;
